<div class="invoice-banner" *ngIf="invoicesList?.length > 0 && currentInvoice">
  <div class="icon">
    <img src="../../../../assets/icons/warning_alert.svg" />
  </div>

  <div class="banner-message">
    <strong>Alert:</strong> We were unable to process payment for invoice No. {{ currentInvoice.invoiceID }}. Please review your payment details.
  </div>

  <div class="banner-actions">
    <button class="details-button" (click)="goToInvoicePage()">
      See Details
      <mat-icon>chevron_right</mat-icon>
    </button>

    <div class="pagination">
      <button
        *ngIf="currentIndex > 0"
        class="pagination-button"
        (click)="previousInvoice()">
        <mat-icon>chevron_left</mat-icon> Previous
      </button>

      <div class="pagination-text">
        <span class="page">{{ currentPage }}</span> of <span class="page">{{ totalPages }}</span>
      </div>

      <button
        *ngIf="currentIndex < totalPages - 1"
        class="pagination-button"
        (click)="nextInvoice()">
        Next <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>
</div>
